import { STORAGE_KEYS } from '~/storage-keys';

/**
 * Lembra quem usou o app por último para detectar troca de usuário no login.
 * Fica fora da sessão de propósito: o logout apaga a sessão, mas a marca do último
 * usuário precisa sobreviver para comparar com o próximo.
 */
export function readLastUserId(): number | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS.lastUserId);
    if (raw === null) return null;
    const parsed = Number(raw);
    return Number.isInteger(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function rememberUserId(userId: number): void {
  try {
    localStorage.setItem(STORAGE_KEYS.lastUserId, String(userId));
  } catch {
    /* storage indisponível: sem marca, o próximo login não limpa nada a mais */
  }
}

/** Verdadeiro quando alguém já usou o app neste navegador e não é `nextUserId`. */
export function hasUserChanged(nextUserId: number): boolean {
  const previous = readLastUserId();
  return previous !== null && previous !== nextUserId;
}
